import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
import './styles/fonts.css';
import './styles/admin.css';

import { Dark, Notify, Quasar } from 'quasar';
import { createApp } from 'vue';

import App from './App.vue';
import { createBugIAmVuePlugin } from './integrations/bugiam-vue';
import { router } from './router';

const app = createApp(App);

app
  .use(Quasar, {
    plugins: {
      Dark,
      Notify,
    },
    config: {
      dark: false,
      brand: {
        primary: '#4F46E5',
        secondary: '#111827',
        accent: '#f0b429',
        dark: '#202326',
        positive: '#168a4a',
        negative: '#c93d3d',
        info: '#207f96',
        warning: '#d99020',
      },
    },
  })
  .use(
    createBugIAmVuePlugin({
      router,
      projectId: 'prj_39befc660a89f4c69fe5',
      apiKey: 'pk_9edbec99c43d533303ee276bb9d1246ae820086af6956e81',
      baseUrl: 'https://bug-i-am.de',
      release: 'frontend@2026-04-24',
      maxBreadcrumbs: 50,
    }),
  )
  .use(router)
  .mount('#app');
